/**
 * @class away.pool.MaterialPoolBase
 */
var _Render_ElementsBase = /** @class */ (function () {
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function _Render_ElementsBase(stage, renderMaterialClassPool, renderGroup) {
        this._abstractionPool = new Object();
        this._stage = stage;
        this._renderMaterialClassPool = renderMaterialClassPool;
        this._renderGroup = renderGroup;
    }
    Object.defineProperty(_Render_ElementsBase.prototype, "stage", {
        get: function () {
            return this._stage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(_Render_ElementsBase.prototype, "renderGroup", {
        /**
         *
         * @returns {IRenderEntity}
         */
        get: function () {
            return this._renderGroup;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * //TODO
     *
     * @param elementsOwner
     * @returns IElements
     */
    _Render_ElementsBase.prototype.getAbstraction = function (material) {
        return (this._abstractionPool[material.id] || (this._abstractionPool[material.id] = new this._renderMaterialClassPool[material.assetType](material, this)));
    };
    /**
     * //TODO
     *
     * @param elementsOwner
     */
    _Render_ElementsBase.prototype.clearAbstraction = function (material) {
        delete this._abstractionPool[material.id];
    };
    _Render_ElementsBase.prototype._includeDependencies = function (shader) {
    };
    _Render_ElementsBase.prototype._getVertexCode = function (shader, registerCache, sharedRegisters) {
        return "";
    };
    _Render_ElementsBase.prototype._getFragmentCode = function (shader, registerCache, sharedRegisters) {
        return "";
    };
    return _Render_ElementsBase;
}());
export { _Render_ElementsBase };
